import { FC } from 'react';

import useAdminSupplementInquiryStatusById from '../../store/hooks/useAdminSupplementInquiryStatusById';
import StatusCount from '../StatusCount/StatusCount';

import { IAdminSupplementStatusCountProps } from './AdminSupplementStatusCount.interface';
import { getStatusIcon } from './utils';

const AdminSupplementStatusCount: FC<IAdminSupplementStatusCountProps> = ({
  className,
  value,
  count,
  hideLabel,
}) => {
  const adminSupplementStatus = useAdminSupplementInquiryStatusById(value);

  if (!adminSupplementStatus) return null;

  return (
    <StatusCount className={className} icon={getStatusIcon(value)} count={count}>
      {!hideLabel && adminSupplementStatus.name}
    </StatusCount>
  );
};

export default AdminSupplementStatusCount;
